var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02_koncepcje",
    "data-name": "02_koncepcje",
    transform: "translate(35.755 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.465 8.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(24.104 28.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4524",
    "data-name": "Path 4524",
    d: "M481.263,391.868v31.159c0,3.91-3.933,7.531-10.143,9.207V394.75a.232.232,0,0,1,.145.134c.867,2.332,2.606,3.926,4.6,3.926,3.048,0,5.575-3.821,5.284-8.07A5.953,5.953,0,0,1,481.263,391.868Z",
    transform: "translate(-446.009 -366.101)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4525",
    "data-name": "Path 4525",
    d: "M368.182,311.322c.29,4.249-2.236,8.07-5.284,8.07-2,0-3.737-1.594-4.6-3.926a.227.227,0,0,0-.145-.134.276.276,0,0,0-.087-.005.22.22,0,0,0-.192.192,7.254,7.254,0,0,1-14.41,0,.22.22,0,0,0-.192-.192.276.276,0,0,0-.087.005.232.232,0,0,0-.145.134c-.869,2.332-2.606,3.926-4.6,3.926-3.048,0-5.576-3.821-5.284-8.07v-.005a6.6,6.6,0,0,1,.5-1.507,7.75,7.75,0,0,1,.791-1.331L345.2,293.73l.04.029c-.8,1.73.974,3.505,3.971,3.97a9.592,9.592,0,0,0,2.905,0c3-.466,4.773-2.24,3.971-3.97l.04-.029L366.9,308.479a7.871,7.871,0,0,1,.791,1.331,6.6,6.6,0,0,1,.5,1.507v.005Z",
    transform: "translate(-333.037 -286.683)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4526",
    "data-name": "Path 4526",
    d: "M403.548,412.821V450.3a26.889,26.889,0,0,1-2.923.615,29.89,29.89,0,0,1-9.122,0,27.322,27.322,0,0,1-2.923-.615V412.821a.274.274,0,0,1,.087-.005.22.22,0,0,1,.192.192,7.254,7.254,0,0,0,14.41,0,.22.22,0,0,1,.192-.192A.274.274,0,0,1,403.548,412.821Z",
    transform: "translate(-378.437 -384.172)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M409.917,261.948c.8,1.73-.974,3.505-3.971,3.97a9.594,9.594,0,0,1-2.905,0c-3-.466-4.775-2.24-3.971-3.97l-.04-.029,4.958-6.79a.626.626,0,0,1,1.012,0l4.958,6.79Z",
    transform: "translate(-386.866 -254.873)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M342.793,394.75v37.484c-6.209-1.676-10.143-5.3-10.143-9.207V391.868a5.956,5.956,0,0,1,.109-1.128c-.294,4.249,2.236,8.07,5.284,8.07,2,0,3.738-1.594,4.6-3.926a.223.223,0,0,1,.145-.134Z",
    transform: "translate(-332.65 -366.101)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "bulb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M283.292,136.789a41.671,41.671,0,0,1-12.877,30.169,49.4,49.4,0,0,0-11.971,17.337l-.241-.1a11.354,11.354,0,0,1-4.225,3.9c-6.913,3.988-18.116,3.988-25.029,0a11.327,11.327,0,0,1-4.214-3.888l-.16.065a49.5,49.5,0,0,0-11.965-17.317,41.783,41.783,0,1,1,70.685-30.169Z",
    transform: "translate(-199.73 -95)",
    fill: "none",
    stroke: "#dbb258",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M370.349,586.85l.241.1q-.5,1.23-.909,2.5a52.573,52.573,0,0,0-1.628,6.323h-.013c-.054.279-.1.549-.152.825a54.343,54.343,0,0,0-.811,8.112c0,1.552-1,3.065-2.961,4.363-.292.19-.617.384-.963.564a17.484,17.484,0,0,1-4.439,1.518,24.777,24.777,0,0,1-5.052.51h-.005a21.278,21.278,0,0,1-9.492-2.027,13.113,13.113,0,0,1-1.286-.78c-1.77-1.222-2.644-2.68-2.644-4.147a53.342,53.342,0,0,0-.811-8.117c-.044-.274-.1-.544-.149-.82h-.011a53.616,53.616,0,0,0-1.63-6.323c-.274-.854-.58-1.692-.914-2.521l.16-.065a11.313,11.313,0,0,0,4.214,3.888c6.913,3.99,18.116,3.99,25.029,0A11.337,11.337,0,0,0,370.349,586.85Z",
    transform: "translate(-311.878 -497.656)",
    fill: "none",
    stroke: "#dbb258",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M391.925,708.424v.005a10.626,10.626,0,0,1-21.235-.219,12.96,12.96,0,0,0,1.286.778,21.272,21.272,0,0,0,9.492,2.026h.005a24.649,24.649,0,0,0,5.052-.51,17.438,17.438,0,0,0,4.439-1.518,10.121,10.121,0,0,0,.963-.564Z",
    transform: "translate(-339.687 -597.008)",
    fill: "none",
    stroke: "#dbb258",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 156,
    height: 156,
    transform: "translate(-35.755 -9)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.bede2bbcc820e22424708a4e67fbd7c7.svg";
export { ForwardRef as ReactComponent };